define([
    'underscore',
    'edge/platform/base/BaseCtrl',
    'edge/quoteandbind/common/models/Submission',
    'edge/platform/util/LocalDateUtil',
    'edge/platform/basler/util/UrlUtil',
], (_, BaseCtrl, Submission, LocalDateUtil, UrlUtil) => {
    const fn = function (
        $scope, $state, $stateParams, LoadSaveService, ModalService, wizardFlowService,
        qnbCompositeFlowDefn, ViewModelService, viewModelContext, returnStateFn,
        errorStateFn, CampaignDataService, MFPPromotionService, ContextService, BaslerVehicleSearchService, LoggingService,
        $window, BaslerLoggingConstants, VisitorIdService

    ) {
        const ctrl = Object.create(BaseCtrl);
        const parentWizardState = 'baseQnbWizard';

        ctrl.init = function () {
            const stepToStateMapping = {
                returnHome: model => returnStateFn(model),
                confirmation: model => ['qnbconfirmation', {
                    quoteSummary: model.value,
                    returnStateInfo: returnStateFn(model.value),
                }],
                error: model => errorStateFn(model),
            };

            const presetPropertyIfParamIsSet = (objectToPreset, propertyName, paramValue) => {
                if (paramValue) {
                    objectToPreset[propertyName] = paramValue;
                }
            };
            const flowfactory = wizardFlowService(qnbCompositeFlowDefn, parentWizardState, stepToStateMapping);

            if ($stateParams.quoteID) { //resume draft submission
                const submissionLoadPromise = LoadSaveService.retrieveSubmission('quoteandbind', $stateParams);
                ModalService.showProgressDialog('', submissionLoadPromise);

                submissionLoadPromise.then((submissionData) => {

                    LoggingService.logInfo(BaslerLoggingConstants.LOAD, undefined, submissionData);

                    if (submissionData === undefined || submissionData.quoteID === undefined) {
                        throw Error;
                    }

                    const submission = new Submission(submissionData);

                    // periodstartdate is required to be in the future or today
                    viewModelContext.PeriodStartDateInFuture = true;

                    const submissionVM = ViewModelService.create(submission, 'pc', 'edge.capabilities.quote.dto.QuoteDataDTO', viewModelContext);

                    // Reset registrationDate for leasing
                    if (ContextService.isPartnerLeasingProduct()) {
                        submissionVM.draftData.lobs.mFPLine.vehicles.forEach((vehicle) => {
                            vehicle.registrationDate = LocalDateUtil.toLocalDate(new Date());
                        });
                    }

                    flowfactory.resume(submissionVM, $stateParams);
                }).catch(() => {
                    const errorPromise = ModalService.showError(
                        'quoteandbind.controllers.BaslerInitialCtrl.Error',
                        'quoteandbind.controllers.BaslerInitialCtrl.NoQuoteWithThatNumber'
                    ).result;
                    errorPromise.then(() => {
                        const returnData = returnStateFn({quoteID: $stateParams.quoteID});
                        //return the home page
                        $state.go(returnData[0], returnData[1]);
                    });
                });
            } else {
                // Motorcyclemode is intialized in BaslerInitialCtrl

                const submission = new Submission(undefined, $stateParams.productCode, $stateParams.subproductInputParam, $stateParams.empMode);

                if ($stateParams.account) {
                    submission.draftData.accountHolder = $stateParams.account;
                    submission.draftData.accountNumber = $stateParams.account.accountNumber;
                    submission.draftData.policyAddress = $stateParams.account.primaryAddress;
                }

                if ($stateParams.advisorNumber) {
                    submission.draftData.directAdvisorNumber = $stateParams.advisorNumber;
                }

                if ($stateParams.producerForCommissionSplit) {
                    submission.draftData.producerForCommissionSplit = $stateParams.producerForCommissionSplit;
                }

                if ($stateParams.firstRegistrationYear && $stateParams.firstRegistrationMonth && $stateParams.uniqueVehicleIdentifier) {
                    BaslerVehicleSearchService.presetVehicleInformation(decodeURIComponent($stateParams.uniqueVehicleIdentifier), $stateParams.firstRegistrationYear, $stateParams.firstRegistrationMonth);
                }

                const campaignData = CampaignDataService;
                if (campaignData && !_.isEmpty(campaignData)) {
                    // 'campaignData' obj contains all attributes defined in campaignUrlParams.json as key/value
                    // need to copy them to 'submission.draftData.trackingCode '
                    submission.draftData.trackingCode = _.map(campaignData, (objValue, objKey) => {
                            return { codeValue: objValue, codeName: objKey };
                        });
                }

                const promotion = MFPPromotionService.getPromotion($window.location.search);
                if (promotion) {
                    submission.draftData.promotion = {
                        title: promotion.title,
                        promotionItems: promotion.promotionItems,
                    };
                }

                // For a new Submission periodstartdate is required to be in the future or today
                viewModelContext.PeriodStartDateInFuture = true;

                presetPropertyIfParamIsSet(submission.draftData.accountHolder.contact, 'dateOfBirth', $stateParams.birthDate);
                presetPropertyIfParamIsSet(submission.draftData.accountHolder.contact, 'nationality', $stateParams.nationality);
                presetPropertyIfParamIsSet(submission.draftData.accountHolder.contact.primaryAddress, 'postalCode', $stateParams.postalCode);

                const submissionVM = ViewModelService.create(submission, 'pc', 'edge.capabilities.quote.dto.QuoteDataDTO', viewModelContext);
                flowfactory.start(submissionVM, $stateParams);

                LoggingService.logInfo(BaslerLoggingConstants.START);
            }
        };

        return ctrl.create($scope);
    };
    fn.$inject = ['$scope', '$state', '$stateParams', 'qnb.LoadSaveService', 'ModalService', 'WizardFlowService',
        'qnb.CompositeFlowDefn', 'ViewModelService', 'qnb.ViewModelCtx', 'qnb.returnStateFn',
        'qnb.errorStateFn', 'CampaignDataService', 'MFPPromotionService', 'ContextService', 'BaslerVehicleSearchService', 'LoggingService', '$window', 'BaslerLoggingConstants'];

    return fn;
});



// WEBPACK FOOTER //
// ../common/js/src/edge/quoteandbind/common/controllers/QuoteEntryCtrl.js